// extracted by mini-css-extract-plugin
module.exports = {"root":"Snackbar_root__kw_e_","wrapper":"Snackbar_wrapper__6Qlvw","fadeIn":"Snackbar_fadeIn___gi8l","link":"Snackbar_link__6SSHa","closeButton":"Snackbar_closeButton__KS952"};